# frozen_string_literal: true

module Engine
  module Game
    module G1866
    end
  end
end
